import request from '../../api/request';

/**
 * SURVEYS DRAFT SECTION
 */
const SECTION_SCHEDULE = {
  GET_CLASSROOM_AVAILABILITY: (sectionId: number | string) =>
    `/maintainers-portal/subject-sections/modification-section/edit/${sectionId}/schedules/get-classroom-availability`,
};

export async function getClassroomAvailability(
  sectionId: number | string,
  params: any,
) {
  return request<any[]>(
    SECTION_SCHEDULE.GET_CLASSROOM_AVAILABILITY(sectionId),
    {
      params,
    },
  );
}
